import React, {Component} from "react";
import Nprogress from "nprogress";
import ReactPlaceholder from "react-placeholder";
import "nprogress/nprogress.css";
import {connect} from "react-redux";

import "react-placeholder/lib/reactPlaceholder.css";
import CircularProgress from "components/CircularProgress";

import {fetchUser} from '../util/API'


export default function asyncComponent(importComponent) {

  const mapStateToProps = ({auth}) => {

    const {loader, alertMessage, showMessage, authUser, logedInUser} = auth;
    return {loader, alertMessage, showMessage, authUser, logedInUser}
  }
  class AsyncFunc extends Component {
    constructor(props) {
      super(props);
      this.state = {
        component: null,
        userData:""
      };
    }

    componentWillMount() {
      Nprogress.start();
    }

    componentWillUnmount() {
      this.mounted = false;
    }

    async componentDidMount() {
      this.mounted = true;
      const {default: Component} = await importComponent();
      Nprogress.done();
      if (this.mounted) {
        this.setState({
                 component: <Component {...this.props} user={this.props.logedInUser} />
               });

        // fetchUser()
        // .then(res => {
        //   if (res.data['status']==200)
        //   {
        //     this.setState({
        //       component: <Component {...this.props} user={res["data"]["LogedInUserInfo"]} />
        //     });
        //   } else {
        //     // window.location="/signin"
        //   }
        // })
        // .catch(error => {
        //     // window.location="/signin"
        // });
      }

    }

    render() {
      const Component = this.state.component || <CircularProgress/>;
      return (
        <ReactPlaceholder type="text" rows={7} ready={Component !== null}>
          {Component}
        </ReactPlaceholder>
      );
    }
  }

  return connect(mapStateToProps, ) (AsyncFunc);
}
